import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { fetchClearOrder, fetchOrderExpireDate } from 'Store/Order/thunks';
import { getOrderExpireDate, getIsFetchingOrder, getOrderContentCount } from 'Store/Order/selectors';
import OrderCountDown from 'Components/OrderCountDown/OrderCountDown';

interface IPropsInternal {
  expireDate: Date;
  isFetching: boolean;
  numberOfReservatedItems: number;
  fetchClearOrder: () => void;
  fetchOrderExpireDate: () => void;
}

interface IState {
  secondsLeft: number;
  isOverTime: boolean;
}

type Props = IPropsInternal & RouteComponentProps<{}>;

class OrderCountDownContainer extends React.PureComponent<Props, IState> {
  private counter: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      secondsLeft: this.countSecondsLeft(this.props.expireDate),
      isOverTime: false,
    }
  }

  componentDidMount() {
    if (this.props.expireDate) {
      if (this.state.secondsLeft > 0) {
        this.startCountDown();
      } else {
        this.handleOverTime();
      }
    } else {
      this.props.fetchOrderExpireDate();
    }
  }

  componentWillUnmount() {
    this.clearCountDown();
  }

  componentWillReceiveProps(nextProps: Props) {

    if (
      this.props.numberOfReservatedItems === 0 &&
      nextProps.numberOfReservatedItems > 0
    ) {
      this.props.fetchOrderExpireDate();
    }

    const nextExpireTime = nextProps.expireDate ? nextProps.expireDate.getTime() : -1;
    const prevExpireTime = this.props.expireDate ? this.props.expireDate.getTime() : -1;

    if (nextExpireTime !== prevExpireTime) {
      this.setState({ 
        secondsLeft: this.countSecondsLeft(nextProps.expireDate),
      }, () => this.startCountDown());
    }
  }

  countSecondsLeft = (date: Date) => {
    return date ? Math.round((date.getTime() - Date.now() ) / 1000) : -1;
  }

  tick = () => {
    const secondsLeft = this.state.secondsLeft - 1;

    if (secondsLeft >= 0) {
      this.setState({ secondsLeft });
    } else {
      this.handleOverTime();
    }
  }

  startCountDown = () => {
    this.clearCountDown();

    if (this.state.secondsLeft && this.state.secondsLeft > 0) {
      this.counter = setInterval(this.tick, 1000);
    }
  }

  clearCountDown = () => {
    clearInterval(this.counter);
  }

  handleOverTime = () => {
    this.clearCountDown();
    this.setState({ isOverTime: true });
  }

  onCancel = () => {
    this.props.fetchClearOrder();
    this.props.history.replace('/');
  }

  render() {
    if (!this.props.expireDate) {
      return null;
    }
    
    const { secondsLeft, isOverTime } = this.state;
    const minutes = Math.floor( secondsLeft / 60);
    const seconds = secondsLeft - (minutes * 60);

    return (
      <OrderCountDown
        minutes={ minutes }
        seconds={ seconds }
        isOverTime={ isOverTime }
        onCancel={ this.onCancel }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    expireDate: getOrderExpireDate(state),
    isFetching: getIsFetchingOrder(state),
    numberOfReservatedItems: getOrderContentCount(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchClearOrder,
    fetchOrderExpireDate,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderCountDownContainer);


// WEBPACK FOOTER //
// ./src/components/OrderCountDown/OrderCountDownContainer.tsx